/**
 * Created by lari on 08/06/2017.
 */
(function () {
  'use strict';
  angular.module('vcdms.vcpdfprinter')
    .component('pdfprinterform', {
      restrict: 'E',
      bindings: {
        pdfprinter: '<',
        parentsave: '&',
        oncancel: '&'
      },
      templateUrl: 'vcdms/vcpdfprinterform-component.tpl.html',
      controllerAs: 'vm',
      controller:
        function () {
          let vm = this;
          vm.save = save;
          vm.cancel = cancel;

          vm.$onInit = function () {
            vm.lastpdfprinter = angular.copy(vm.pdfprinter);
          };
          
          function save() {
            if (!angular.equals(vm.pdfprinter, vm.lastpdfprinter)) {
              vm.lastpdfprinter = angular.copy(vm.pdfprinter);
              vm.parentsave({pdfprinter: vm.pdfprinter});
            }
          }
          
          function cancel() {
            vm.pdfprinter = angular.copy(vm.lastpdfprinter);
            vm.oncancel();
          }
          
        }// controller
    }); // component

// klammerfriedhof
}());
